import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import Dashboard from './pages/Dashboard';
import LeadManagement from './pages/LeadManagement';
import EmailTemplates from './pages/EmailTemplates';
import DataImport from './pages/DataImport';
import Settings from './pages/Settings';
import Websites from './pages/Websites';
import Chatbots from './pages/Chatbots';
import Layout from './components/Layout';
import Login from './pages/Login';
import { AuthProvider } from './components/Auth';
import Auth from './components/Auth';

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <AuthProvider>
          <Routes>
            {/* Public route - accessible without authentication */}
            <Route path="/login" element={<Login />} />
            
            {/* Protected routes - require authentication */}
            <Route path="/" element={
              <Auth>
                <Layout>
                  <Dashboard />
                </Layout>
              </Auth>
            } />
            <Route path="/leads/:id" element={
              <Auth>
                <Layout>
                  <LeadManagement />
                </Layout>
              </Auth>
            } />
            <Route path="/email-templates" element={
              <Auth>
                <Layout>
                  <EmailTemplates />
                </Layout>
              </Auth>
            } />
            <Route path="/import" element={
              <Auth>
                <Layout>
                  <DataImport />
                </Layout>
              </Auth>
            } />
            <Route path="/settings" element={
              <Auth>
                <Layout>
                  <Settings />
                </Layout>
              </Auth>
            } />
            <Route path="/websites" element={
              <Auth>
                <Layout>
                  <Websites />
                </Layout>
              </Auth>
            } />
            <Route path="/chatbots" element={
              <Auth>
                <Layout>
                  <Chatbots />
                </Layout>
              </Auth>
            } />
            
            {/* Redirect unknown routes to home */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </Router>
    </QueryClientProvider>
  );
}

export default App; 